module.exports = __webpack_public_path__ + "img/settings-icon.ea86a0c0.svg";